import { ButtonBaseProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaLink } from '../buttons';
import { Tile } from '../tile';
import { EmobilityToolIcon } from './icons';

const useStyles = makeStyles<{ size: 'small' | 'large' }>({ name: 'EmobilityNavigationTile' })((theme, props) => ({
	root: {
		width: '100%',
		height: '100%',
		alignItems: 'center',
		padding: 24,
		paddingTop: 40,
		minHeight: 280
	},
	icon: {
		height: props.size === 'small' ? 116 : 140,
		marginTop: props.size === 'small' ? -16 : -20,
		marginBottom: props.size === 'small' ? -16 : -20
	},
	panelTitle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexGrow: 1
	},
	title: {
		textAlign: 'center',
		fontSize: '24px',
		lineHeight: '28px',
		fontWeight: 'bold',
		marginTop: props.size === 'small' ? 22 : 28,
		marginBottom: props.size === 'small' ? 22 : 28
	},
	linkRoot: {},
	linkIcon: {}
}));

export type EmobilityNavigationTileClasses = Partial<ReturnType<typeof useStyles>['classes']>;

export type EmobilityNavigationTileProps = Omit<ButtonBaseProps, 'classes' | 'onClick'> & {
	href: string;
	toolCode: string;
	title: string;
	size?: 'small' | 'large'
	textButton?: string;
	classes?: EmobilityNavigationTileClasses;
	onClick?: (toolCode: string, href: string, label: string) => void;
};

export const EmobilityNavigationTile: React.FC<EmobilityNavigationTileProps> = (props) => {
	const { toolCode, title, textButton, children, classes, size, href, onClick, ...other } = props;
	const { classes: styles, cx } = useStyles({ size }, { props });

	return (
		<Tile
			data-test-href={href}
			data-test='emobility-navigation-tile'
			id={'emobility-navigation-tile-' + toolCode}
			classes={{ root: cx(styles.root) }}
			onClick={() => onClick?.(toolCode, href, title)}
			{...other}>
			<EmobilityToolIcon toolCode={toolCode} className={cx(styles.icon)} />
			<div className={cx(styles.panelTitle)}>
				<span className={cx(styles.title)}>{title}</span>
			</div>
			<SkodaLink classes={{ root: styles.linkRoot, icon: styles.linkIcon }}>
				{textButton}
			</SkodaLink>
		</Tile>
	);
};
